<template>
  <div class="flex items-center">
    <div class="flex-1 border-b border-eerie-black/20 dark:border-body-gray" />
    <div class="px-4 text-dark-gunmetal dark:text-body-gray">
      or
    </div>
    <div class="flex-1 border-b border-eerie-black/20 dark:border-body-gray" />
  </div>
</template>
